import {
  FETCH_COURSE_DETAILS_REQUEST,
  FETCH_COURSE_DETAILS_SUCCESS,
  FETCH_COURSE_DETAILS_FAILURE,
  FETCH_LESSONS_REQUEST,
  FETCH_LESSONS_SUCCESS,
  FETCH_LESSONS_FAILURE,
  FETCH_STUDENTS_REQUEST,
  FETCH_STUDENTS_SUCCESS,
  FETCH_STUDENTS_FAILURE,
} from "../actions/getEnrolledCoursesDataAction";

interface CourseState {
  loading: boolean;
  course: any;
  lessons: any[];
  students: any[];
  error: string | null;
}

const initialState: CourseState = {
  loading: false,
  course: null,
  lessons: [],
  students: [],
  error: null,
};

const courseReducer = (state = initialState, action: any): CourseState => {
  switch (action.type) {

    case FETCH_COURSE_DETAILS_REQUEST:
      return {
        ...state,
        loading: true,
        course: null,        
      };

    case FETCH_LESSONS_REQUEST:
      return {
        ...state,
        loading: true,
        lessons: [],       
      };

    case FETCH_STUDENTS_REQUEST:
      return {
        ...state,
        loading: true,
        students: [],       
      };

    case FETCH_COURSE_DETAILS_SUCCESS:
      return {
        ...state,
        loading: false,
        course: action.payload,
      };

    case FETCH_LESSONS_SUCCESS:
      return {
        ...state,
        loading: false,
        lessons: action.payload,
      };

    case FETCH_STUDENTS_SUCCESS:
      return {
        ...state,
        loading: false,
        students: action.payload,
      };

    case FETCH_COURSE_DETAILS_FAILURE:
    case FETCH_LESSONS_FAILURE:
    case FETCH_STUDENTS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    default:
      return state;
  }
};

export default courseReducer;